/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Sort: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="sort" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M963.3333333333331 226.6666666666668L680 510L760.75 589.3333333333334L906.6666666666666 443.4166666666667V1076.6666666666667H1020V443.4166666666667L1165.9166666666665 589.3333333333333L1246.6666666666665 510L963.3333333333331 226.6666666666668zM396.6666666666667 1133.3333333333333L113.3333333333333 850L194.0833333333333 770.6666666666666L340 916.5833333333331V283.3333333333335H453.3333333333333V916.5833333333331L599.2499999999999 770.6666666666666L680 850L396.6666666666667 1133.3333333333333z" : "M770.6666666666667 181.3333333333333L544 408L608.6 471.4666666666667L725.3333333333334 354.7333333333333V861.3333333333333H816V354.7333333333333L932.7333333333333 471.4666666666666L997.3333333333334 408L770.6666666666667 181.3333333333333zM317.3333333333334 906.6666666666666L90.6666666666667 680L155.2666666666667 616.5333333333333L272 733.2666666666667V226.6666666666667H362.6666666666667V733.2666666666667L479.4 616.5333333333333L544 680L317.3333333333334 906.6666666666666z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Sort.displayName = `Blueprint5.Icon.Sort`;
export default Sort;
